import { render } from "./OnDemandYearlyIncome.vue?vue&type=template&id=43a3e8b5"
import script from "./OnDemandYearlyIncome.vue?vue&type=script&lang=js"
export * from "./OnDemandYearlyIncome.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__